import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import baseStyle from "../../../../styles/base.module.pcss";
import style from "./styles.module.pcss";
var cx = classNames.bind(_objectSpread(_objectSpread({}, style), baseStyle));
export var DevicePreviewSkeleton = function DevicePreviewSkeleton(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', "wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'skeleton-caption', "skeleton-caption--".concat(size))
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'skeleton-subcaption', "skeleton-subcaption--".concat(size))
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('content-wrapper', "content-wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper-gallery', "wrapper-gallery--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), "picture--".concat(size))
  }), size !== 's' && /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper-gallery-items')
  }, [1, 2, 3, 4].map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('skeleton-line', 'gallery-item'),
      key: item
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('description-wrapper', "description-wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'description-caption', "description-caption--".concat(size))
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('promo-wrapper', "promo-wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'promo-big-line', "promo-big-line--".concat(size))
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'promo-small-line', "promo-small-line--".concat(size))
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), "button--".concat(size))
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'color-option', "color-option--".concat(size))
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'capacity-option', "capacity-option--".concat(size))
  }), /*#__PURE__*/React.createElement("div", {
    className: cx("characteristics-wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), "characteristics-caption--".concat(size))
  }), [1, 2, 3, 4].map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('skeleton-line', "common--".concat(size), "characteristics-option--".concat(size)),
      key: option
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('skeleton-line', "common--".concat(size), 'next-link', "next-link--".concat(size))
  }))));
};